import { SxProps } from "@mui/material";

export const wrapperRoutes: SxProps = {
  position: "relative",
  width: "710px",
  maxWidth: "100%",
  "&>div": {
    borderRadius: "0 0 8px 8px",
    paddingBottom: "0",
  },
  "&>div:last-of-type": {
    height: "64vh",
    overflowY: "auto",
    top: "24px",
  },
  ".active": {
    border: "2px solid #FF9800 !important",
  },
  ".MuiGrid-root": {
    border: "none",
  },

  "@media (max-width: 1200px)": {
    width: "488px",
    "&>div:last-of-type": {
      height: "auto",
      paddingTop: "0",
    },
  },
};

export const wrapperIcons: SxProps = {
  position: "absolute",
  zIndex: "1",
  background: "#363562",
  top: "-33px",
  right: "0",
  height: "57px",
  width: "100%",
  textAlign: "center",
  borderRadius: "0 8px 0 0 !important",
  justifyContent: "space-between",
  "& h4": {
    fontWeight: "700",
    fontSize: "1.7rem",
  },
  "& .MuiCircularProgress-root": {
    top: "15px",
    right: "-30px",
  },
};

export const wrappeBox: SxProps = {
  background: "linear-gradient(90deg, #22376A 0%, #211043 100%)",
  borderRadius: "8px",
  padding: "5px 15px",
  margin: "15px auto",
  cursor: "pointer",
  position: "relative",
};

export const wrapperTitle: SxProps = {
  borderBottom: "1px solid #FFFFFF21 !important",
  minHeight: "35px",
  display: "flex",
  padding: "5px 0",
  flexWrap: "wrap",
  position: "relative",
  "&>div": {
    borderRadius: "3px",
    margin: "5px",
    padding: "5px",
    fontWeight: "700",
  },
  "& .tag_item": {
    border: "1px solid #FF9800",
    color: "#FF9800",
    borderRadius: "3px",
  },
  "& .kyc_item": {
    border: "1px solid rgb(255, 50, 50)",
    color: "rgb(255, 50, 50)",
    borderRadius: "3px",
  },
};

export const wrapperMain: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  paddingTop: "10px",
  position: "relative",
  "& h4": {
    fontWeight: "700",
    fontSize: "20px",
  },
  "& p": {
    textAlign: "right",
  },
};
export const wrapperFooter: SxProps = {
  display: "flex",
  padding: "15px 10px",
  "& img": {
    margin: "0 5px",
    position: "relative",
    top: "4px",
  },
  "& span": {
    opacity: "0.7",
  },
};

export const wrapperSave: SxProps = {
  position: "absolute",
  bottom: "-73px",
  right: "0",
};

export const wrapperPartner: SxProps = {
  background: "rgb(51, 61, 107)",
  padding: "10px 20px",
  borderRadius: "8px",
  marginBottom: "10px",
  display: "flex",
  justifyContent: "center",
  "&>div": {
    minWidth: "100px",
    textAlign: "center",
  },
  "@media (max-width: 900px)": {
    padding: "0 20px",
  },
};

export const wrapperError: SxProps = {
  color: "#EF4444",
  textAlign: "center",
  padding: "30px 10px",
  "& span": {
    fontSize: "1.6rem",
    fontWeight: "700",
  },
  "& p": {
    fontSize: "1.3rem",
    marginTop: "10px",
  },
};

export const wrapperModal: SxProps = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  pt: 2,
  px: 4,
  pb: 3,
  width: 700,
  maxWidth: "100%",
  background: "#333d6b",
  borderRadius: "8px",
  maxHeight: "90vh",
  overflowY: "auto",
  "& h5": {
    color: "#FF9800",
  },
  "& p": {
    fontSize: "1.2rem",
    lineHeight: "22px",
    opacity: "0.8",
  },

  "& button": {
    position: "absolute",
    right: "10px",
    top: "11px",
    color: "#FF9800",
    "& svg": {
      fontSize: "2.2rem",
    },
  },
};
